import { render, staticRenderFns } from "./g25.vue.pug?vue&type=template&id=40baaeaa&lang=pug&"
import script from "./g25.vue.js?vue&type=script&lang=js&"
export * from "./g25.vue.js?vue&type=script&lang=js&"
import style0 from "./g25.vue.css?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports